import _filter from 'lodash/filter';
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';

function checkStatus (condition, resolve) {
  if (condition.multiple) {
    const name = condition.name;
    if (condition.operator === 'OR') {
      for (let i = 0; i < resolve.value.length; i++) {
        // console.log('checkStatus multiple', resolve.value[i].value, condition[name])
        let find = _find(condition[name], (o) => {
          return o[name] === resolve.value[i].value
        });

        if (find) {
          // console.log('WHAAA', condition[name], resolve.value[i].value);
          return true
        }
      }
    }
  } else {
    return condition[resolve.name] === resolve.value;
  }
}

function resolveConditionByType (condition, resolve) {
  if (condition.multiple) {
    // console.log(2.2, 'composite is-multiple', condition);
    condition.resolved = checkStatus(condition, resolve)
  } else {
    // console.log(2.3, 'composite only', condition);
    if (resolve.hasOwnProperty('checked')) {
      // console.log('2.3.1', 'checked', condition, resolve.name, resolve.value);
      if (condition[resolve.name] === resolve.value) {
        condition.resolved = resolve.checked;
      }
    } else {
      condition.resolved = checkStatus(condition, resolve)
    }
  }
  return condition
}

const changeConditionState = (context, payload) => {
  const idxArr = context.getters.findConditionIndex(payload.name); // индекс нужен для использования в Vue.set
  // console.log(2, 'action changeConditionState', payload.value, payload.name, idxArr);
  if (idxArr.length) {
    for (let i = 0; i < idxArr.length; i++) {
      // console.log(2, payload.name, payload.value, idxArr[i]);
      let idx = idxArr[i];

      let mutationData = {};
      mutationData.idx = idx;
      let condition = context.getters.getConditionByIndex(idx);
      mutationData.condition = condition;
      if (condition.composite) {
        // console.log(2.1, 'composite', condition);
        let itemConditions = _filter(condition.items, payload.name);

        if (itemConditions.length > 1) {
          // это условие запилино для групп чекбоксов, т.к. у них одинаковые имена
          let itemCondition = _find(itemConditions, (o) => {
            return o[payload.name] === payload.value;
          });
          let idx = _findIndex(condition.items, (o) => {
            return o[payload.name] === payload.value;
          });
          itemCondition = resolveConditionByType(itemCondition, payload);
          condition.items[idx] = itemCondition;
        } else {
          resolveConditionByType(itemConditions[0], payload);
        }
        // console.log(2.4, condition.items);
        context.commit('changeConditionState', Object.assign(mutationData, { condition: condition }));

        condition = context.getters.getConditionByIndex(idx);
        let resolvedCount = _filter(condition.items, 'resolved');
        if (condition.operator === 'OR') {
          condition.resolved = resolvedCount && resolvedCount.length > 0
        } else {
          condition.resolved = resolvedCount && resolvedCount.length === condition.items.length
        }
        context.commit('changeConditionState', Object.assign(mutationData, { condition: condition }))
      } else if (condition.multiple) {

      } else {
        // console.log(2.1, 'simple');
        if (payload.hasOwnProperty('checked')) {
          condition.resolved = payload.checked
        } else {
          condition.resolved = checkStatus(condition, payload)
        }
        context.commit('changeConditionState', Object.assign(mutationData, { condition: condition }))
      }
    }
  }
};

const setConditions = (context, payload) => {
  for (let i = 0; i < payload.elements.length; i++) {
    let el = payload.elements[i];

    const hasCondition = el.hasOwnProperty('cond');

    if (hasCondition) {
      el.cond.resolved = false;
      if (Array.isArray(el.cond)) {
        let cond = {};
        cond.composite = true;
        cond.name = [];
        cond.resolved = false;

        if (typeof el.cond[0] === 'string') {
          cond.operator = el.cond[0]; // если первый элемент строка - это опраетор AND, OR, etc...
          el.cond.shift()
        }
        // дальше перебираю условия
        cond.items = el.cond.map((item) => {
          // снова проверка сложное/простое условие и есть/нет оператор
          let itemCond = {};
          if (Array.isArray(item)) {
            const conditionName = Object.keys(item[1])[0];
            itemCond = {
              multiple: true,
              operator: item[0], // условие - or, and и т.д.
              resolved: false,
              name: conditionName
            };
            item.shift();
            itemCond[conditionName] = item; // имя вопроса, одинаковое во всех условиях
            cond.name.push(conditionName)
          } else {
            let name = Object.keys(item)[0];
            itemCond = item;
            itemCond.name = name;
            itemCond.resolved = false;
            cond.name.push(name)
          }
          return itemCond
        });
        el.cond = cond
      } else {
        el.cond.name = [Object.keys(el.cond)[0]]
      }

      el.condition = hasCondition ? el.cond : null;

      context.commit('setCondition', el.cond)
    }
  }
};

export default {
  changeConditionState,
  setConditions
}
